import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import SimpleParallax from "simple-parallax-js/vanilla";

window.Alpine = Alpine
Alpine.plugin(focus)
Alpine.start()

import AOS from 'aos';

AOS.init({
  once: true,
  disable: 'mobile', // Désactive AOS sur mobile
});

if (window.innerWidth > 768) {
  var image = document.getElementsByClassName('parallax');
  new SimpleParallax(image, {
    orientation: 'bottom',
  });
}



